import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, checking } = useAuth();
  if (checking) return <main className="page-loading" data-testid="admin-session-loading">Checking your secure session…</main>;
  return user ? children : <Navigate to="/login" replace />;
};